import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AvanceTrabajoDTO } from "app/main/apps/shared/interfaces/avance-trabajo.interface";

@Component({
    selector: "app-dialog-ubicacion",
    templateUrl: "./dialog-ubicacion.component.html",
    styleUrls: ["./dialog-ubicacion.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogUbicacionComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogUbicacionComponent>,

        @Inject(MAT_DIALOG_DATA) public data: { avance: AvanceTrabajoDTO }
    ) {}

    ngOnInit(): void {}
}
